// extracted by mini-css-extract-plugin
export var cookies_modal_buttons_block = "styles-module--cookies_modal_buttons_block--65cQw";
export var cookies_modal_container = "styles-module--cookies_modal_container--AwfQ2";
export var fadeAnim = "styles-module--fade-anim--2BoUa";